import { fetchApi } from "./api";

export const fetchHrisEmployeeData = async (emailId) => {
  const data = await fetchApi(`/api/signature/hris-employee?emailId=${encodeURIComponent(emailId)}`);
  return data;
};
